/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Thesis6Inputs */

const en_job_form_enum_thesis6 = /** @type {(inputs: Job_Form_Enum_Thesis6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thesis`)
};

const de_job_form_enum_thesis6 = /** @type {(inputs: Job_Form_Enum_Thesis6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschlussarbeit`)
};

/**
* | output |
* | --- |
* | "Thesis" |
*
* @param {Job_Form_Enum_Thesis6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_thesis6 = /** @type {((inputs?: Job_Form_Enum_Thesis6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Thesis6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_thesis6(inputs)
	return en_job_form_enum_thesis6(inputs)
});
export { job_form_enum_thesis6 as "job_form_enum_THESIS" }